<template>
  <LoginPage module-name="Billing" locale-storage-key="billing_locale" />
</template>

<script setup>
import { LoginPage } from '@shared/components/intercom'
</script>
